import { render, staticRenderFns } from "./SimilarStartups.vue?vue&type=template&id=4f0699f0&scoped=true&"
import script from "./SimilarStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./SimilarStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0699f0",
  null
  
)

export default component.exports